/*
 * @Author: huangzq
 * @Date: 2020-03-17 18:21:26
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-03-18 16:03:48
 * @Desc: 上传完成组件：全部完成、部分失败
*/
<template>
  <div class="upload-finished">
    <div class="finished-title">
      <mk-iconfont
        v-if="failNum"
        icon-class="icon-mk-cuowutishi"
      />
      <mk-iconfont
        v-else
        icon-class="icon-mk-chenggongtishi"
      />
      <span>{{ failNum?failText:successText }}</span>
    </div>
    <div
      v-if="showNum"
      class="finished-num"
    >
      <span>{{ successNum }}个成功，</span>
      <span>{{ failNum }}个失败</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UploadFinished',
  props: {
    // 成功文案
    successText: {
      type: String,
      default: '上传完成'
    },
    // 失败文案
    failText: {
      type: String,
      default: '上传完成'
    },
    // 是否显示成功、失败数量
    showNum: {
      type: Boolean,
      default: true
    },
    // 成功数量
    successNum: {
      type: Number,
      default: 0
    },
    // 失败数量
    failNum: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang='scss' scoped>
.upload-finished {
  line-height: 24px;

  .finished-title {
    display: flex;
    color: #262626;
    font-size: 16px;

    .iconfont {
      margin-right: 16px;
      font-size: 22px;
    }

    .icon-mk-chenggongtishi {
      color: #52c41a;
    }

    .icon-mk-cuowutishi {
      color: #f5222d;
    }
  }

  .finished-num {
    margin-left: 40px;
    color: #595959;
    font-size: 13px;
  }
}
</style>
